var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('a-layout',{staticStyle:{"padding":"24px 0","background":"#fff"}},[_c('a-layout-content',{style:({ padding: '0 24px', minHeight: '200px' })},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }